import request from '@/utils/request'

// List public coupons (is_public = true)
export function listPublicCoupons(params) {
  return request({
    url: '/coupon/distribution/public',
    method: 'get',
    params:params
  })
}

// List coupons by business type
export function listCouponsByBusiness(pageNum,pageSize,businessType, busiEntityId) {
  return request({
    url: '/coupon/distribution/byBusiness',
    method: 'get',
    params: { pageNum,pageSize,businessType, busiEntityId }
  })
}

// Get nearby coupons based on location
export function getNearByCoupons(pageNum,pageSize,latitude, longitude, radius = 5000, entityName="") {
  return request({
    url: '/coupon/distribution/nearby',
    method: 'get',
    params: { pageNum,pageSize,latitude, longitude, radius, entityName }
  })
}

// Get flash sale coupons
export function getFlashSaleCoupons() {
  return request({
    url: '/coupon/distribution/flash-sale',
    method: 'get'
  })
}

// Purchase a coupon
export function purchaseCoupon(couponId) {
  return request({
    url: '/coupon/distribution/purchase',
    method: 'post',
    data: { id: couponId }
  })
}
